import { StatusDot as DesignStatusDot, type StatusDotStatus } from '@cere/cere-design-system';

interface Props {
  status: 'active' | 'revoked' | string;
  size?: number;
}

export function StatusDot({ status, size = 8 }: Props) {
  return (
    <DesignStatusDot
      status={statusToTone(status)}
      size={size}
      pulse={isActiveStatus(status)}
      aria-label={`status: ${status}`}
    />
  );
}

function statusToTone(status: string): StatusDotStatus {
  const normalized = status.toLowerCase();
  if (['active', 'completed', 'succeeded', 'success', 'ready', 'connected'].includes(normalized)) return 'success';
  if (['failed', 'error', 'dead'].includes(normalized)) return 'error';
  if (['processing', 'running'].includes(normalized)) return 'info';
  if (['pending', 'paused', 'awaiting-proxy', 'warning'].includes(normalized)) return 'warning';
  if (['revoked', 'closed', 'cancelled', 'disabled', 'idle'].includes(normalized)) return 'neutral';
  return 'warning';
}

function isActiveStatus(status: string): boolean {
  return ['active', 'processing', 'running'].includes(status.toLowerCase());
}
